import { render, staticRenderFns } from "./ExpenseSubCategoryNew.vue?vue&type=template&id=5854db66&"
import script from "./ExpenseSubCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ExpenseSubCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports